import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { api, formatApiError } from '@/lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [admin, setAdmin] = useState(null); // null = checking, false = anon, obj = authed
    const [checking, setChecking] = useState(true);

    const refresh = useCallback(async () => {
        try {
            const { data } = await api.get('/auth/me');
            setAdmin(data);
        } catch {
            setAdmin(false);
        } finally {
            setChecking(false);
        }
    }, []);

    useEffect(() => {
        refresh();
    }, [refresh]);

    const login = async (username, password) => {
        try {
            const { data } = await api.post('/auth/login', { username, password });
            if (data?.token) localStorage.setItem('uncloned_admin_token', data.token);
            setAdmin({ username: data.username });
            return { ok: true };
        } catch (e) {
            return { ok: false, error: formatApiError(e) };
        }
    };

    const logout = async () => {
        try { await api.post('/auth/logout'); } catch (e) { void e; }
        localStorage.removeItem('uncloned_admin_token');
        setAdmin(false);
    };

    return (
        <AuthContext.Provider value={{ admin, checking, login, logout, refresh }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);
